import { Component, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { SubSink } from "subsink";
import { NbcLoggerService } from "../../../shared/logger/nbc-logger.service";
import { TemplateService } from "../../../shared/services/template.service";
import * as _ from "lodash";

@Component({
    selector: "create-template",
    templateUrl: "./modal-create-template.component.html",
    standalone: false
})
export class ModalCreateTemplateComponent implements OnInit {
    constructor(
        public bsModalRef: BsModalRef,
        private templateService: TemplateService,
        private log: NbcLoggerService
    ) {}

    public onSync!: Subject<any>;
    sub = new SubSink();
    modalTitle = "Create Template";
    buAccess: any = {};
    templates: any;
    allTemplates: any;

    submitted = false;

    defaultOrderBy = "name";
    defaultReverseSort = false;
    timecards: any = [];
    queryContainer: any;
    showErrormsg = false;
    errorMsg = "";
    name: any = "";

    getQueryContainer() {
        return {
            query: this.templateService.getTemplateListQuery(
                this.buAccess.businessUnitId,
                null,
                null,
                null
            ),
        };
    }

    onCreate() {
        this.showErrormsg = false;
        this.errorMsg = "";
        this.submitted = true;
        if (this.validate()) {
            if (!this.hasTemplateNameUsed(this.name)) {
                const template = this.getNewTemplate();
                this.upsertTemplates(template);
            } else {
                this.showErrormsg = true;
                this.errorMsg = "Template with same name already exists";
                this.submitted = false;
            }
        } else {
            this.showErrormsg = true;
            this.errorMsg = "Template Name is required";
            this.submitted = false;
        }
    }

    getNewTemplate() {
        const template = {
            id: -1,
            name: this.name,
            businessUnit: {
                id: this.buAccess.businessUnitId,
            },
        };
        return template;
    }

    validate() {
        if (_.trim(this.name).length <= 0) {
            return false;
        }
        return true;
    }

    hasTemplateNameUsed(name) {
        return _.some(this.allTemplates, function (o) {
            return _.lowerCase(o.name) === _.lowerCase(name);
        });
    }

    upsertTemplates(template) {
        this.log.trace("upsert template");
        this.templateService
            .upsertTemplate(template, this.timecards)
            .subscribe({
                next: (result) => {
                    this.log.trace(
                        "upsert templates got data" + JSON.stringify(result)
                    );
                },
                error: (err) => {
                    this.log.error(
                        "upsert templates got an error: " + JSON.stringify(err)
                    );
                },
            });
        //this.onSync.next();
        this.onSync.next(''); //TODO: Revisit
        this.bsModalRef.hide();
    }

    getTimesheetTemplates() {
        this.log.trace("Get Timesheet Template");
        this.queryContainer.query.sortByColumn = this.defaultOrderBy;
        this.queryContainer.query.isActive = "All";
        this.sub.sink = this.templateService
            .getTemplates(this.queryContainer.query)
            .subscribe({
                next: (result) => {
                    this.allTemplates = result.reference.items;
                },
                error: (err) => {
                    this.log.error(err);
                    this.log.showModalError(
                        "Unable to load the timesheet template at this time. Please try again later."
                    );
                },
            });
    }

    cancel() {
        this.log.trace("canceled modal");
        this.bsModalRef.hide();
    }

    ngOnInit() {
        this.onSync = new Subject();
        //this.templates = this.templates;
        this.buAccess = _.get(this, "userBuAccess");
        this.queryContainer = this.getQueryContainer();
        this.getTimesheetTemplates();
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
